import { LanguagesEnum } from "@/enums";

export default {
  cityName: (state) => {
    if (typeof state.queryParams.sub.xq === "object") {
      if (
        state.queryParams.sub.xo === LanguagesEnum.fa ||
        state.queryParams.sub.xo === LanguagesEnum.ar ||
        state.queryParams.sub.xo === LanguagesEnum.ur
      ) {
        return state.queryParams.sub.xq.cityFaName;
      }

      return state.queryParams.sub.xq.cityEnName;
    }

    return state.queryParams.sub.xq;
  },
};
